export default "__VITE_ASSET__fGLQifJI__"